import {SignalRHub, SignalREvent, LicenseStatus, ViewMode} from '../../constants/dataEnum';
import {setLicense, showLicenseCountdown} from '../actions/licenceStateAction';
import {invokeAPI} from './commonBusiness';
import {getLastLicenseData, setLicenseData} from './stateBusiness';

export const importLicense = (licenseString) => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.LICENSE_IMPORT, licenseString));

    console.log(response);
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const activateTrialLicense = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.LICENSE_ACTIVATE_TRIAL));

    console.log(response);
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const activateLicense = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.LICENSE_ACTIVATE));

    console.log(response);
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const getLicenseData =
  (isSetLicense = true) =>
  async (dispatch) => {
    console.debug('getLicenseData start');
    let response;

    try {
      response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.LICENSE_GET_DATA));
      await dispatch(setLicenseData(response));
    } catch (err) {
      response = await dispatch(getLastLicenseData());

      console.log(err);
    }

    if (response && isSetLicense) {
      dispatch(setLicense(response));
    }

    console.debug('getLicenseData end, response: ', response);

    return response;
  };

export const handleTrialCountdownNotification = () => (dispatch, getState) => {
  const state = getState();
  const {sessionState, licenseState} = state;

  if (licenseState.status !== LicenseStatus.TRIAL) {
    return;
  }

  const {userId} = sessionState.user;
  const key = `lastTrialCountdownDate_${userId}`;
  const remainingDays = parseInt(licenseState.remainingDays, 10);

  const value = window.localStorage.getItem(key);

  if ((!value && remainingDays <= 14) || remainingDays < value) {
    window.localStorage.setItem(key, remainingDays);
    dispatch(showLicenseCountdown());
  }
};

export const shouldUseLicense = () => (dispatch, getState) => {
  const {appState} = getState();
  if (appState.viewMode === ViewMode.PLATE_TYPE_EDITOR) {
    return false;
  }
  return true;
};

export const checkLicenseValidity = () => async (dispatch) => {
  const licenseData = await dispatch(getLicenseData(false));
  const isLicenseValid = !(
    licenseData.status === LicenseStatus.TRIAL_EXPIRED || licenseData.status === LicenseStatus.TEMPORARY_EXPIRED
  );

  return isLicenseValid;
};
